import { Injectable, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { NavigationExtras, Router } from "@angular/router";
import { FiltrosEnum } from "@appNeo/core/helpers/enums/filtros-enum";
import { FiltrosService } from "@appNeo/neoCore/services/filtros/filtros.service";
import { AccionesDialogComponent } from "@appNeo/neoShared/components/acciones-dialog/acciones-dialog.component";
import { FormularioComponent } from "@appNeo/neoShared/components/formulario/formulario.component";
import { ImagenPrincipalPerfilComponent } from "@appNeo/neoShared/components/imagen-principal-perfil/imagen-principal-perfil.component";
import { NotificacionComponent } from "@appNeo/neoShared/components/notificacion/notificacion.component";
import { AccionDialogEnum } from "@appNeo/neoShared/helpers/enums/AccionDialog.enum";
import { IconEnum } from "@appNeo/neoShared/helpers/enums/Icon.enum";
import { NotificacionEnum } from "@appNeo/neoShared/helpers/enums/Notificacion.enum";
import { TipoPaginadorEnum } from "@appNeo/neoShared/helpers/enums/TipoPaginador.enum";
import { IFormInput } from "@appNeo/neoShared/helpers/interfaces/IForm-input";
import { IPerfilPropiedad } from "@appNeo/neoShared/helpers/interfaces/IPerfilPropiedad";
import { Paginator } from "@appNeo/neoShared/models/paginator/paginator";
import { EntityService } from "@datorama/akita";
import { environment } from "@environments/environment";
import { BehaviorSubject } from "rxjs";
import { Subscription } from "rxjs/internal/Subscription";
import { AuxiliarService } from "../auxiliar/auxiliar.service";
import { IColumnaTablaLink, IColumnaTablaEstado, IColumnaTabla, IBotonAccionCabeceraTabla, TablaService, AccionesTablaEnum } from "../tabla/tabla.service";
import { RUTA_PADRE_ADMIN } from "@appNeo/core/global";

export interface IListado {
  // Notificaciones
  notificacionPrincipal: NotificacionComponent;
  // Botoneras
  botoneraDialogEliminar?;
  // Dialog Creación
  dialogCreacion: TemplateRef<any>;
  accionesDialogCreacion: AccionesDialogComponent;
  formularioCreacion: FormularioComponent;
  refDialogFormulario: MatDialogRef<any, any>;
  inputsFormulario?: IFormInput[];
  // Configuracion necesaria para tabla genérica. Datos filas y filtros
  identificadorTabla: string;
  identificadorFiltrosTabla: FiltrosEnum;
  columnasTabla: IColumnaTabla[];
  paginator: Paginator;
  tipoPaginador: TipoPaginadorEnum;
  botonCrearElemento?: IBotonAccionCabeceraTabla;
  inputsFiltros?: IFormInput[];
  // Subscripciones
  subDataTable: Subscription;
  subTotalData: Subscription;
  subscriptionPermisoEdicion: Subscription;
  permisoEdicion$: BehaviorSubject<boolean>;
  // Estados
  loading: boolean;
  grabando: boolean;
  establecerColumnasTabla();
  subscriptionTotalData();
  subcripcionPermisoEdicion();
  cargarTabla();
  establecerBotoneraTabla?();
  establecerFiltros?();
  onAplicarFiltrosTabla(filtros);
  onAplicarAccionCabeceraTabla?(IBotonAccionCabeceraTabla);
  onAplicarOrdenarColumnasTabla(datos: object []);
  onAplicarCambiarPaginadorTabla(paginador);
  mostrarNotificacion(message: string, status: string, dialogAction?: AccionDialogEnum);
  onAccionDialogCreacion();
  onCerrarDialogCreacion?();
}



export interface IPerfil {
  entidad?: object;
  nombreEntidad: string;
  idEntidad?: string;
  subEntidad: Subscription;
  subCargaEntidad: Subscription;
  propiedadesPerfil: IPerfilPropiedad[];
  formInput: IFormInput [];
  cargando?: boolean;
  grabando: boolean;
  urlPadre: string;
  refDialogFormulario?;
  notificacionPerfilFormularioEntidad: NotificacionComponent;
  imagenPrincipalProducto?: ImagenPrincipalPerfilComponent;
  cargarDatos();
  subscriptionEntidad();
  cargarEntidad();
  onAccionContenedorCabecera?(evento);
}

export interface IMiniatura {
  '_mini/grid': string;
  '_mini/listado': string;
  '_mini/perfil': string;
}


export const botoneraEliminarGenerica = [
    {
      label: 'No, mantener',
      id: 'btn-cancelar',
      tipoAccion: 'cerrar',
      type: 'button',
      color: '',
      disabled: false,
      activo: true,
      flat: true
    },
    {
      label: 'Sí, eliminar',
      id: 'btn-confirmar',
      tipoAccion: 'accion',
      type: 'button',
      color: 'primary',
      disabled: false,
      activo: true,
      flat: true
    },
  ];

  export const botoneraAccionesImgGenerica =  [
    {
      idAccion: AccionesTablaEnum.Editar,
      tooltip: 'Editar',
      icono: true,
      iconClass: 'icon-20 icon-ibm--edit',
      disabled: false,
    },
    {
      idAccion: AccionesTablaEnum.Eliminar,
      tooltip: 'Eliminar',
      icono: true,
      iconClass: 'icon-20 icon-ibm--trash-can text-danger',
      disabled: false,
    },
  ];



@Injectable({
    providedIn: 'root'
  })
export class UtilidadesLayoutService {  
    constructor(
      private router: Router,
      private dialog: MatDialog,
      private auxiliar: AuxiliarService
    ) { }
    mapColumnaAccionesTablaXPermiso(columnas, tienePermisoEdicion) {
      let columnasSinPermiso = [];
      if (!tienePermisoEdicion) {
        columnasSinPermiso.push('actions');
      }
      return columnas.filter(columna => !columnasSinPermiso.includes(columna.key));
    }

    mapEntidadFiltrosOrdenacionTabla (datos, filtrosService, identificadorFiltro){
      const entidadFiltros = Object.assign({}, filtrosService.getFiltros(identificadorFiltro) );
      entidadFiltros.orden =  datos.active;
      entidadFiltros.tipoOrden = datos.direction;
      return entidadFiltros;
    }

  configuracionInicialPaginador(paginator, tipoPaginador: TipoPaginadorEnum) {
    if (tipoPaginador === TipoPaginadorEnum.online) {
        paginator._pagina = 0;
        paginator._numeroElementosPagina = 10;
      }
      paginator._numeroElementosPagina = (paginator._numeroElementosPagina && paginator._numeroElementosPagina!== null) 
        ? paginator._numeroElementosPagina 
        : environment.numero_elementos_paginador;
      return paginator;
    }

    aplicarAccionCabeceraTabla(accion: IBotonAccionCabeceraTabla, dialogView: TemplateRef<any>, dialog: MatDialog,  refDialogFormulario: MatDialogRef<any, any>) {
      switch(accion.id) {
        case AccionesTablaEnum.Crear : 
        refDialogFormulario = dialog.open(dialogView, {disableClose: true});
        break;
      }
    }


    aplicarAccionCabeceraPerfil(evento, entityService, nombreEntidad, refDialogFormulario, dialog, cargando, dialogoConfirmarEliminar, grabando, formulario, entidad, notificacion) {
      if (evento.id === 'btn-editar') {
        entityService.editando = true;
      }
      if (evento.id === 'btn-eliminar') {
        this.confirmarEliminarDefecto(refDialogFormulario, dialogoConfirmarEliminar);
      }
      if( evento.id === 'btn-cancelar-edicion') {
        notificacion.eliminarNotificaciones();
        entityService.editando = false;
      }
  
      if (evento.id === 'btn-guardar') {
        this.submitFormulario(formulario, entityService, entidad, nombreEntidad, grabando, cargando, notificacion);
      }
    }


    submitFormulario(formulario: FormularioComponent, entityService, entidad, nombreEntidad, grabando: boolean, cargando, notificacion) {
      grabando =  true;
      let objeto_fDF = (formulario) ? formulario.validaCampos( false ) : undefined;
  
      if ( (objeto_fDF && objeto_fDF.formulario.invalid) ) {
          formulario.formValueReset = true;
          grabando = false;
          if (notificacion) {
          notificacion.eliminarNotificaciones();
          notificacion.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Rellene los campos obligatorios', true, IconEnum.Error);
          }
        return;
      }
  
      let valores_fPF   = (objeto_fDF && objeto_fDF.formulario.valid ) ? objeto_fDF.valores : {};
      this.editarEntidadDefecto(valores_fPF, entityService, entidad, nombreEntidad,  notificacion, grabando, cargando);
    }

    editarEntidadDefecto(peticion, entityService, entidad, nombreEntidad, notificacion, grabando, cargando) {
      peticion['activa'] = (peticion?.activa) ? peticion?.activa : '0';
      // console.log('Peticion edicion ', peticion);
      delete peticion.nombre;
      entityService.update(entidad?.id, peticion).subscribe(
        x => {entityService.editando = false; 
          this.showResult(`Edición ${nombreEntidad} realizada con éxito!`, 'ok', AccionDialogEnum.Actualizar, notificacion)
        },
        e => {
          let aviso = (typeof e?.mensaje === 'string') ? e.mensaje: '';
          this.showResult(`Se ha producido un error al editar ${nombreEntidad} ${aviso}`, 'ko', AccionDialogEnum.Actualizar, notificacion);
        }
      );
    }

  showResult(message: string, status: string, dialogAction: AccionDialogEnum, notificacion, grabando?, cargando?, accionesDialogo?: AccionesDialogComponent) {
      if (notificacion) notificacion.eliminarNotificaciones();
      if (status === 'ok') {
        switch (dialogAction) {
          default:
            if (notificacion) notificacion.crearNotificacion(NotificacionEnum.Exito, 'Operación correcta', message, false, IconEnum.Exito, '', true);
            this.dialog.closeAll();
            break;
        }
      }  else {
        switch (dialogAction) {
          case AccionDialogEnum.Crear:
            if (accionesDialogo) {
              accionesDialogo.notificacionDialogo.crearNotificacion(NotificacionEnum.Error, 'Error!', message, true, IconEnum.Error);
            } else {
              if (notificacion) notificacion.crearNotificacion(NotificacionEnum.Error, 'Se ha producido un error', message, true, IconEnum.Error);
            }
            break;
          default:
            if(notificacion) notificacion.crearNotificacion(NotificacionEnum.Error, 'Se ha producido un error', message, true, IconEnum.Error);
        }
      }
      // grabando = false;
      // cargando = false;
    }
  

    confirmarEliminarDefecto(refDialogFormulario, dialogoConfirmarEliminar) {
      refDialogFormulario = this.dialog.open(dialogoConfirmarEliminar, {disableClose: true});

    }
    

    cargarTabla(filtrosService: FiltrosService, identificadorFiltro: FiltrosEnum, paginator, subDataTable: Subscription, entityService, tipoPaginador, tablaService: TablaService, route) {
      setTimeout( () => {
        let filtros = filtrosService.getFiltros(identificadorFiltro);
        // paginator = this.configuracionInicialPaginador(paginator, tipoPaginador);
        subDataTable = entityService.getAll(tipoPaginador, paginator, filtros)
          .subscribe((items: any[]) => {
            // console.log('Resultado tabla ', items);
            tablaService.data = new MatTableDataSource(this.mapRowTabla(items, route));       
          });    
      });
    }

    mapRowTabla(rows, adminPage, iconoActivo = 'icon-20 icon-ibm--checkmark--outline', colorActivo = '#00D385', iconoInactivo = 'icon-20 icon-ibm--close--outline', colorInactivo = 'red') {
      let rowsMap;
      rowsMap = rows.map( row => {
        let objecto = Object.assign({}, row);
        let dataLinkColumnTable: IColumnaTablaLink = { id:  objecto.id, pag: RUTA_PADRE_ADMIN + adminPage};
        objecto['identificadorMapping'] = dataLinkColumnTable;
        objecto['nombreMapping'] = dataLinkColumnTable;

        let claseIcono = '';
        let colorIcono = '';

        if (objecto.hasOwnProperty('ruta')) {
            objecto['imagen'] = {
             src: objecto.ruta,
             alt: objecto?.alt
            }
        }

        if (objecto.hasOwnProperty('activo') || objecto.hasOwnProperty('activa')) {
        if (objecto.activo || objecto.activa) {
          claseIcono = iconoActivo
          colorIcono = colorActivo
        } else {
          claseIcono = iconoInactivo;
          colorIcono =  colorInactivo
        }
        let dataActivo: IColumnaTablaEstado = {id: objecto.id, nombre: '', iconoClase: claseIcono, color: colorIcono};
        if (objecto.hasOwnProperty('activo')) objecto['activo'] = dataActivo;
        if (objecto.hasOwnProperty('activa')) objecto['activa'] = dataActivo;
        if (objecto.hasOwnProperty('visiblePublico')) {
            if (objecto.visiblePublico) {
              claseIcono = iconoActivo
              colorIcono = colorActivo
            } else {
              claseIcono = iconoInactivo;
              colorIcono =  colorInactivo
            }
            let dataActivo: IColumnaTablaEstado = {id: objecto.id, nombre: '', iconoClase: claseIcono, color: colorIcono};
            if (objecto.hasOwnProperty('visiblePublico')) objecto['visiblePublico'] = dataActivo;
            if (objecto.hasOwnProperty('visiblePublico')) objecto['visiblePublico'] = dataActivo;
            return objecto;
          }
          return objecto;
        }        
      });
      return rowsMap;
  }

    imagenPrincipalPerfil(entidad, entidadService, imagenPrincipalProducto: ImagenPrincipalPerfilComponent) {
      entidadService.getImagenPrincipal(entidad.id).subscribe(imgPrincipal => {
        imagenPrincipalProducto.establecer(imgPrincipal);
      }
      )
    }


    editarImagenPrincipalPerfil(datos){
      // console.log('Editar img principal ', datos);
    }

    eliminarImagenDefecto(entidad, entidadService, imagenPrincipalProducto: ImagenPrincipalPerfilComponent){
      // console.log('Eliminar img principal ', entidad.id);
        entidadService.eliminarImagenPrincipal(entidad.id).subscribe(()=>{
          this.imagenPrincipalPerfil(entidad, entidadService,imagenPrincipalProducto);
        });
    }

    submitAccionDialogoConfirmarEliminar(event, entidad, nombreEntidad, entidadService, urlPadre, notificacion) {
      if (event.id == 'btn-confirmar') {
        this.eliminarEntidad(entidadService, entidad, nombreEntidad, urlPadre, notificacion);
      }
    }

    eliminarEntidad(entidadService, entidad, nombreEntidad, urlPadre, notificacion) {
      let notificacionAEnviar: NavigationExtras = {
        queryParams: {
          message: `Eliminación ${nombreEntidad} realizada con éxito!`,
          status: 'ok' ,
          dialogoAction : AccionDialogEnum.Eliminar
        }
      };
  
      entidadService.delete(entidad?.id).subscribe(
        x => {
          this.dialog.closeAll();
          this.router.navigate([ urlPadre ], { state: { notificacion: notificacionAEnviar }})
        },
        e => this.showResult(`Se ha producido un error al intentar eliminar ${nombreEntidad}` + e.data, 'ko', AccionDialogEnum.Eliminar, notificacion)
      );
    }

    getConfiguracionFichero(data) {
      return data.valor;
    }

    mapearConfiguracionFicheroFormatos(data) {
      let _valor = [];
      data.split(',').forEach(formato =>  _valor.push( '.' + formato));
      return data = _valor;
    }

    mapearConfiguracionFicheroTamanoMaximo(data) {
      return this.auxiliar.bytesToMb(data);
    }

}
